export const APPROVAL_TYPES = {
  ORDER: 'order',
  SUPPLIER_LIST: 'supplier_list',
  TENDER_RECOMMENDATION: 'tender_recommendation',
};
